import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { useEffect, useRef } from "react";
export var useHandleResize = function(handleResize) {
    var fireImmediately = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        fireImmediately: false
    }).fireImmediately;
    var isInitialRender = useRef(true);
    useEffect(function() {
        var _getWindow;
        if (isInitialRender.current && fireImmediately) {
            handleResize();
        }
        if (isInitialRender.current) {
            isInitialRender.current = false;
        }
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener("resize", handleResize, false);
        return function() {
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener("resize", handleResize, false);
        };
    }, [
        fireImmediately,
        handleResize
    ]);
};
